import {AwardGrid} from '@sdox/ui'

import type {XcNwBlock_AwardTypeBlockRowType_Fragment} from '@sdox/api'

export const BlockAwardRow = ({items}: XcNwBlock_AwardTypeBlockRowType_Fragment) => {
  return <AwardGrid awards={items} />
}
